/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Ledger_All_PromosInputs */



/**
* | output |
* | --- |
* | "All promos" |
*
* @param {Promo_Ledger_All_PromosInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_ledger_all_promos = /** @type {((inputs?: Promo_Ledger_All_PromosInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Ledger_All_PromosInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Toutes les promos")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todas las promos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Todas as promos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutte le promo")
	return /** @type {LocalizedString} */ ("All promos")
});